@if (!contentLoaded) {
  <app-content-loader></app-content-loader>
}
@if (contentLoaded) {
  <div class="step-container columns is-desktop" >
    <app-aside-bar
      [showEvenWithoutStatement]="false"
      [statement]="statement"
      [isBusiness]="isBusiness"
      [workFlowController]="workFlowController"
      >
    </app-aside-bar>
    <div class="choose-profile" [class.grid]="!isBusiness">
      @if (isBusiness) {
        <h1 class="title">
          <span>{{ 'PROFILE.TITLE_FIRST' | translate }}</span>
          <span>{{ 'PROFILE.TITLE_SECOND' | translate }}</span>
        </h1>
        <div class="description">
          {{ 'PROFILE.DESCRIPTION' | translate }}
        </div>
      }
      <div class="choose-profile_wrap" [class.a_center]="currentStep===2 || currentStep===3">
        @if (!isBusiness) {
          @if (currentStep===1) {
            <h1 class="title_42" >
              <span>{{ 'PROFILE_BC.STEP_1_TITLE' | translate }}</span>
            </h1>
            <p class="subdesc">
              {{ 'PROFILE_BC.STEP_1_DESC' | translate }}
            </p>
          }
          @if (currentStep===2) {
            <h1 class="title_42" >
              @if (statement.relationshipStatus===2) {
                <span>{{ 'PROFILE_BC.STEP_2_MARRIAGE_TITLE' | translate }}</span>
              }
              @if (statement.relationshipStatus===3) {
                <span>{{ 'PROFILE_BC.STEP_2_PARTNERSHIP_TITLE' | translate }}</span>
              }
              @if (statement.relationshipStatus===4) {
                <span>{{ 'PROFILE_BC.STEP_2_WIDOWED_TITLE' | translate }}</span>
              }
              @if (statement.relationshipStatus===5) {
                <span>{{ 'PROFILE_BC.STEP_2_SEPARATION_TITLE' | translate }}</span>
              }
              @if (statement.relationshipStatus===6) {
                <span>{{ 'PROFILE_BC.STEP_2_DIVORCE_TITLE' | translate }}</span>
              }
            </h1>
            @if (statement.relationshipStatus===2) {
              <p class="subdesc">{{ 'PROFILE_BC.STEP_2_MARRIAGE_DESC' | translate }}</p>
            }
            @if (statement.relationshipStatus===3) {
              <p class="subdesc">{{ 'PROFILE_BC.STEP_2_PARTNERSHIP_DESC' | translate }}</p>
            }
            @if (statement.relationshipStatus===4) {
              <p class="subdesc">{{ 'PROFILE_BC.STEP_2_WIDOWED_DESC' | translate }}</p>
            }
            @if (statement.relationshipStatus===5) {
              <p class="subdesc">{{ 'PROFILE_BC.STEP_2_SEPARATION_DESC' | translate }}</p>
            }
            @if (statement.relationshipStatus===6) {
              <p class="subdesc">{{ 'PROFILE_BC.STEP_2_DIVORCE_DESC' | translate }}</p>
            }
          }
          @if (currentStep===3) {
            <h1 class="title_42" >
              <span>{{ 'PROFILE_BC.STEP_3_TITLE' | translate }}</span>
            </h1>
            <p class="subdesc">
              {{ 'PROFILE_BC.STEP_3_DESC' | translate }}
            </p>
          }
        }
        <div class="choose-profile__content">
          @if (errors?.marital_status) {
            <div class="alert-box" #error>{{ errors.marital_status[0] }}</div>
          }
          @if (statement) {
            <div>
              @if (!isBusiness) {
                <app-profile-edit-bc #profileEditRef [statement]="statement" [errors]="errors"
                [(epValidator)]="epValidator" [(currentStep)]="currentStep" (statementChangedEvent)="statementChangedEvent($event)"></app-profile-edit-bc>
              }
              @if (isBusiness) {
                <app-profile-edit #profileEditRef [statement]="statement" [errors]="errors"
                [(epValidator)]="epValidator" [(currentStep)]="currentStep"></app-profile-edit>
              }
            </div>
          }
        </div>
      </div>
    </div>
    @if (statement) {
      <app-tools-bar [statement]="statement" [buttons]="buttons"></app-tools-bar>
    }
  </div>
}
